import IconWrapper, { IconWrapperProps } from '@repo/ui/src/components/IconWrapper';

interface ShareIconProps extends IconWrapperProps {
  color?: string;
}

const ShareIcon = ({ color = 'currentColor', ...rest }: ShareIconProps) => (
  <IconWrapper viewBox="0 0 40 40" width="40" title="Share Recipe" {...rest}>
    <path
      stroke={color}
      d="M14.72 16.6398L20 11.8398L25.28 16.6398"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      stroke={color}
      d="M27.2 22.3999V26.7199C27.2 26.8472 27.1368 26.9693 27.0243 27.0593C26.9118 27.1493 26.7592 27.1999 26.6 27.1999H13.4C13.2409 27.1999 13.0883 27.1493 12.9758 27.0593C12.8633 26.9693 12.8 26.8472 12.8 26.7199V22.3999"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      stroke={color}
      d="M20 12.7998V21.4398"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </IconWrapper>
);

export default ShareIcon;
